module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAAG+Fv5aAAAAAXNSR0IArs4c6QAAAJxJREFUGBl1jzESwjAQA2MaijwoVWoavkYVHpF38CcmQ2VWcs5cGLgZ25JOpxsPtdZxiILcjAGqLcgcjiJA58JztWhjE4JvaHeTuHbTElwRbVNXHDujjye0M6Bth4C171FKedqPsMigBqdazBeaDMcGfJJIeTIPZExfqfKopt6DOJX3EADPA59f9skdpIAXWEf1f+BHwMrA+q0HfwOMBa1cPXjP5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_down_White.png
// module id = YyxH
// module chunks = 1